<template>
  <v-card
    color="#CFD8DC"
  >
    <v-container
      fluid
    >
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-card
            color="#eceff1"
            class="details-card"
          >
            <v-container
              fluid
            >
              <p class="my-p-style">
                Product Type:-
                <font class="font-my-style">
                  {{ appSubscriptionDetails.product_type }}
                </font>
              </p>
              <p class="my-p-style">
                Plan Type:-
                <font
                  v-if="appSubscriptionDetails.plan_type !== null"
                  class="font-my-style"
                >
                  {{ appSubscriptionDetails.plan_type }}
                </font>
                <font
                  v-else
                  class="font-my-style"
                >
                  N/A
                </font>
              </p>
              <p class="my-p-style">
                Created At:-
                <font
                  v-if="appSubscriptionDetails.created_at === null"
                  class="font-my-style"
                >
                  N/A
                </font>
                <font
                  v-else
                  class="font-my-style"
                >
                  {{ appSubscriptionDetails.created_at | convertStringToLocalDatetime }}
                </font>
              </p>
              <p class="my-p-style">
                Trial Ends At:-
                <font
                  v-if="appSubscriptionDetails.trial_ends_at !== null"
                  class="font-my-style"
                >
                  {{ appSubscriptionDetails.trial_ends_at | convertStringToLocalDatetime }}
                </font>
                <font
                  v-else
                  class="font-my-style"
                >
                  N/A
                </font>
              </p>
              <p class="my-p-style">
                Subscription Status:-
                <font
                  class="my-status-style"
                  :color="getColor(appSubscriptionDetails.subscription_status)"
                >
                  {{ appSubscriptionDetails.subscription_status | statusUpdate }}
                </font>
              </p>
              <p class="my-p-style">
                Last Updated:-
                <font
                  v-if="appSubscriptionDetails.updated_at === null"
                  class="font-my-style"
                >
                  N/A
                </font>
                <font
                  v-else
                  class="font-my-style"
                >
                  {{ appSubscriptionDetails.updated_at | convertStringToLocalDatetime }}
                </font>
              </p>
            </v-container>
          </v-card>
        </v-col>
        <centre-spinner
          :loading="loading"
        />
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';

  export default {
    name: 'OrgSubscriptionDetails',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (status) {
        if (status === 'active') {
          return 'Active*';
        } else if (status === 'trial') {
          return 'Trial*';
        } else {
          return 'Inactive';
        }
      },
    },
    data () {
      return {
        loading: false,
      };
    },
    computed: {
      appSubscriptionDetails () {
        return this.$store.getters['organizations/getOrganizationSubscriptionDetails'];
      },
    },
    methods: {
      async fetchOrgSubscriptionDetails (val) {
        this.loading = true;
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationSubscriptionDetails', {
          organizationId: organizationlId,
          appModuleName: val,
        }).then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      getColor (status) {
        if (status === 'active') return '#2E7D32';
        else if (status === 'inactive') return '#C62828'; else return '#EF6C00';
      },
    },
  };
</script>
<style scoped>
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
  text-transform: capitalize;
}
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  margin-bottom: 5px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.address-style {
margin-bottom: 5px;
color: #546E7A;
}
.address-font-style {
  color: #37474F;
}
.my-status-style {
  font-weight: bold;
  font-size: 15px;
}
@media (max-width: 960px) {
  .title-style {
   margin-top: -20px;
  }
}
.details-card {
  border-left: 3px solid #FF3700 !important;
}
</style>
